var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.4 .6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.47 15.43v-1.944H8.73v1.945c-2.556-.38-4.581-2.405-4.961-4.96h1.946V8.729H3.769c.38-2.555 2.405-4.58 4.96-4.96v1.946h1.742V3.769c2.555.38 4.58 2.405 4.96 4.96h-1.945v1.742h1.945c-.38 2.555-2.405 4.58-4.96 4.96zm8.73-6.7h-2.014c-.4-3.517-3.199-6.315-6.715-6.716V0H8.729v2.014c-3.516.4-6.314 3.199-6.715 6.715H0v1.742h2.014c.401 3.516 3.199 6.314 6.715 6.715V19.2h1.742v-2.014c3.516-.4 6.314-3.199 6.715-6.715H19.2V8.729z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.6,
    cy: 9.6,
    r: 2.4,
    fill: "#D8D8D8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.683688cbe7a308b082b0494d4c396ab0.svg";
export { ForwardRef as ReactComponent };